import { Dialog, Toolbar } from "client/Components";
import { useDataInputDialog } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export type SaveSpaceChangesBeforeSwitchDialogProps = {
	onSave: () => void;
	onDiscard: () => void;
	onClose: () => void;
};

const SaveSpaceChangesBeforeSwitchDialog = (props: SaveSpaceChangesBeforeSwitchDialogProps): ReactElement => {
	const {
		onSave,
		onDiscard,
		onClose
	} = props;

	return (
		<Dialog trackingId="unsaved-space-changes-dialog">
			<Dialog.Header
				title={localize("_DoYouWantToSaveChangesMadeToThisSpace")}
				onClose={onClose}
			/>

			<Dialog.Footer>
				<Toolbar>
					<Toolbar.Button
						kind="primary"
						text={localize("_Save")}
						onClick={onSave}
						trackingId="save"
					/>

					<Toolbar.Button
						kind="secondary"
						text={localize("_DontSave")}
						onClick={onDiscard}
						trackingId="discard"
					/>

					<Toolbar.Button
						kind="secondary"
						text={localize("_Cancel")}
						onClick={onClose}
						trackingId="cancel"
					/>
				</Toolbar>
			</Dialog.Footer>
		</Dialog>
	);
};
SaveSpaceChangesBeforeSwitchDialog.displayName = "SaveSpaceChangesBeforeSwitchDialog";

export type SaveSpaceChangesBeforeSwitchDialogInitialData = Omit<
	SaveSpaceChangesBeforeSwitchDialogProps,
	"onSave" | "onDiscard" | "onClose"
>;

export function useSaveSpaceChangesBeforeSwitchDialog(): [
	element: ReactElement | null,
	open: (props: SaveSpaceChangesBeforeSwitchDialogInitialData) => Promise<TryResult<boolean>>
] {
	return useDataInputDialog(
		(props, onClose, onSave) => (
			<SaveSpaceChangesBeforeSwitchDialog
				{...props}
				onClose={onClose}
				onSave={() => onSave(true)}
				onDiscard={() => onSave(false)}
			/>
		)
	);
}
